import { render, staticRenderFns } from "./DepartmentOrgChart.vue?vue&type=template&id=4e01047a"
import script from "./DepartmentOrgChart.vue?vue&type=script&lang=js"
export * from "./DepartmentOrgChart.vue?vue&type=script&lang=js"
import style0 from "./DepartmentOrgChart.vue?vue&type=style&index=0&id=4e01047a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports